/* eslint-disable */
import * as d3 from "d3";
import "./Tooltip.css";
import "../../AxiomTooltip/axiom-chart-tooltip.css";

/*
 * Creates tooltip with provided id that
 * floats on top of visualization.
 * Most styling is expected to come from CSS
 * so check out bubble_chart.css for more details.
 */
function floatingTooltip() {

  // Initially it is hidden.
  hideTooltip();

  /*
   * Display tooltip with provided content.
   * content is expected to be HTML string.
   * event is d3.event for positioning.
   */
  function showTooltip(arrObj, event, className,isOnMouseMove,globalTooltip, duration) {
    // d3.selectAll(".axiomTooltip_ReactD3MultiSeries").remove();
    // d3.selectAll(".axiomDataTip_ReactD3MultiSeries").remove();

    // arrObj.map(function(obj, i) {
    //   var tooltipClass="axiomTooltip_ReactD3MultiSeries";
    //   var isThisDataTip=false;
    //   if(obj.hasOwnProperty("isThisDataTip")===true){
    //     if(obj.isThisDataTip==true){
    //       tooltipClass="axiomDataTip_ReactD3MultiSeries";
    //       isThisDataTip=true;
    //     }
    //   }

    //   d3
    //     .select("body")
    //     .append("div")
    //     .attr("class", "tooltip "+tooltipClass+" axiom-chart-tooltip "+(className?className:""))
    //     .attr("id", "axiomMultiSeriesTooltip_" + i)
    //     .style("pointer-events", "none")
    //     .style("opacity", 1.0)
    //     .style("z-index", 999);

    //   d3
    //     .select("#axiomMultiSeriesTooltip_" + i)
    //     .append("div")
    //     .attr("class", "axiom-chart-tooltip-tip")
    //     .attr("id", "triangle_" + i)
    //     .style("z-index", 999);
    //     $("#axiomMultiSeriesTooltip_" + i).append("<table></table>");
    //     if(isThisDataTip===true){
    //       var closeButtonContent="<thead><tr><td colspan='2'><span class='axiomDataTipClose' id='"+i+"'>Close</span></td> </tr></thead>";  
    //       $("#axiomMultiSeriesTooltip_" + i + " table").append(closeButtonContent);
    //       $("#axiomMultiSeriesTooltip_" + i + " .axiomDataTipClose").on("click",function(d){
    //         var id=$(this).attr("id");
    //         $("#axiomMultiSeriesTooltip_"+id).remove();
    //         $("#triangle_"+id).remove();
    //         if($(".axiomDataTip_ReactD3MultiSeries").length<=0)
    //            d3.selectAll("#"+obj.mainDivId + " #transparentRect").remove();
    //       });
    //     }
    //   $("#axiomMultiSeriesTooltip_" + i + " table").append(obj.content);
    //   // .html(obj.content);
    //   /*$("#axiomMultiSeriesTooltip_" + i).innerWidth($("#axiomMultiSeriesTooltip_" + i + " table").outerWidth());*/
    // });

    var tooltipClass = "axiomTooltip_ReactD3MultiSeries";
    var tooltipObjs = d3.select('body').selectAll(".axiomTooltip_ReactD3MultiSeries").data(arrObj);

    var newElements = tooltipObjs.enter().append("div")
        .attr("class", "tooltip "+tooltipClass+" axiom-chart-tooltip "+(className?className:""))
        .attr("id", function(d, i){ return "axiomMultiSeriesTooltip_" + i; })
        .style("pointer-events", "none")
        .style("opacity", 1)
        .style("z-index", 99999)
        .attr("data-new-element", true);

      newElements.append("div")
        .attr("class", "axiom-chart-tooltip-tip")
        .style("z-index", 99999);
      newElements.each(function(e){
        d3.select(this).append("table").html(e.content);
      }); 

    tooltipObjs.style("opacity", 1)
    
    tooltipObjs.each(function(e){
      d3.select(this).select("table").html(e.content);
    });

    tooltipObjs.exit().remove();

    updatePosition(arrObj, event,isOnMouseMove,globalTooltip, duration);
  }

  /*
   * Hide the tooltip div.
   */
  function hideTooltip() {
    d3.selectAll(".axiomTooltip_ReactD3MultiSeries").style("opacity", 0);
  }

  /*
   * Figure out where to place the tooltip
   * based on d3 mouse event.
   */
  function updatePosition(arrObj, event,isOnMouseMove,globalTooltip, duration) {
    var isGlobalTooltip=false;
    var globalTooltipPosition='middle';
    if((globalTooltip!=null && typeof(globalTooltip)=='object') || (globalTooltip==true) ){
      isGlobalTooltip=true;
    }
    if((globalTooltip!=null && typeof(globalTooltip)=='object')){
      globalTooltipPosition=globalTooltip.position;
    }

    arrObj.map(function(obj, i) {
      var xXtra = 15 ; //20 for padding
      var yXtra = 15 ; //20 for padding
      var y = obj.y;
      var x = obj.x;
      var tt = d3.select("#axiomMultiSeriesTooltip_" + i);
      var triangle = tt.select(".axiom-chart-tooltip-tip");
      var height = $("#axiomMultiSeriesTooltip_" + i).outerHeight();
      var width = $("#axiomMultiSeriesTooltip_" + i).outerWidth();
      obj.mainDivWidth=obj.mainDivWidth || parseFloat(d3.select("#" + obj.mainDivId).attr("width"));
      obj.mainDivHeight=obj.mainDivHeight || parseFloat(d3.select("#" + obj.mainDivId).attr("height"));
      var topOffset = 0;
      var leftOffset = 0;
      var topMinimum = 0;
      var leftMinimum = 0;
      topOffset = $("#" + obj.mainDivId).offset().top-$(window).scrollTop();
      leftOffset = $("#" + obj.mainDivId).offset().left-$(window).scrollLeft();

      topMinimum = 0;
      leftMinimum = $("#" + obj.mainDivId).offset().left;

      var posY=0;
      var posX=0;
     if(isGlobalTooltip==true){
      posY = y - ($("#axiomMultiSeriesTooltip_" + i).outerHeight() + yXtra);
      posX = x ;
     }else if(isOnMouseMove==true){//Cursor type position of tooltip
      posY = obj.y - ($("#axiomMultiSeriesTooltip_" + i).outerHeight() + yXtra) - $(window).scrollTop();
      posX = obj.x - ($("#axiomMultiSeriesTooltip_" + i).outerWidth() / 2) - $(window).scrollLeft() ;
     }else{//CBT: "default" type position of tooltip
      posY = obj.y - ($("#axiomMultiSeriesTooltip_" + i).outerHeight() + yXtra) - $(window).scrollTop();
      posX = obj.x - ($("#axiomMultiSeriesTooltip_" + i).outerWidth() / 2) - $(window).scrollLeft();
     }

     var positionFlag = 0;

      if(isGlobalTooltip==true){
        if(globalTooltipPosition=='top'){
          posX = posX + leftOffset -(width/2);
          posY =posY + topOffset;
          positionFlag=0;
        }else{
          if (posX + width > obj.mainDivWidth ) {
            //CBT:xpos greater than right ,show on Left
            posX = x + leftOffset - (width + (xXtra*1.5));
            posY = y + topOffset - height / 2;
            positionFlag = 2;
          }else {
            //CBT:x Pos less than left,show on Right
            posX = x + leftOffset + 0 + xXtra; //-(0/2);
            posY = y + topOffset - height / 2;
            positionFlag = 3;
          } 
        }
      }else if (isOnMouseMove==false || isOnMouseMove==undefined){
        //CBT:this is for default cursor tooltip
        if (posY > topMinimum){
          //CBT:ypos greater than than top ,show on top
          positionFlag=0;
        }else if (posY <= topMinimum) {
           //CBT:ypos less than top ,show on bottom
          posY = y + yXtra; //+yXtra
          positionFlag = 1;
        }else if (posX + width > obj.mainDivWidth) {
          //CBT:xpos greater than right ,show on Left
          posX = x  - (width + xXtra);
          posY = y + topOffset - height / 2;
          positionFlag = 2;
        }else {
          //CBT:x Pos less than left,show on Right
          posX = x  + 0 + xXtra; //-(0/2);
          posY = y  - height / 2;
          positionFlag = 3;
        } 
      }

      triangle.attr("style", "")
      .style("position", "absolute")
      .style("z-index", 99999)
      .style("pointer-events", "none");
      var triangleTop = 0;
      var triangleLeft = 0;

      triangle.classed('on-top', false);
      triangle.classed('on-bottom', false);
      triangle.classed('on-left', false);
      triangle.classed('on-right', false);
      if (positionFlag == 0) {
        /*triangle
          .style("border-top", "10px solid rgba(255,255,255,0.9)")
          .style("border-left", "15px solid transparent")
          .style("transform", "translateY(-1px)")
          .style("border-right", "15px solid transparent");
        triangleTop ="100%";
        triangleLeft = "calc(50% - 15px)";*/
        triangle.classed("on-top", true);
      }
      else if (positionFlag == 1) {
        /*triangle
          .style("border-bottom", "10px solid rgba(255,255,255,0.9)")
          .style("border-left", "15px solid transparent")
          .style("transform", "translateY(1px)")
          .style("border-right", "15px solid transparent");
          triangleTop ="0%";
          triangleLeft = "calc(50% - 15px)";*/
          triangle.classed("on-bottom", true);
      } else if (positionFlag == 2) {
        /*triangle
          .style("border-left", "10px solid rgba(255,255,255,0.9)")
          .style("border-top", "15px solid transparent")
          .style("transform", "translateX(-1px)")
          .style("border-bottom", "15px solid transparent");
          triangleTop ="calc(50% - 15px)";
          triangleLeft = "100%";*/
          triangle.classed("on-left", true);
      } else if (positionFlag == 3) {
        /*triangle
          .style("border-right", "10px solid rgba(255,255,255,0.9)")
          .style("border-top", "15px solid transparent")
          .style("transform", "translateX(1px)")
          .style("border-bottom", "15px solid transparent");
          triangleTop ="calc(50% - 15px)";
          triangleLeft = "-10px";*/
        triangle.classed("on-right", true);
      }
      if(isGlobalTooltip==true){
        if(tt.attr("data-new-element") == "true"){
          tt.transition().delay(duration).duration(0).style("top", `${posY}px`).style("left", `${posX}px`);
          tt.attr('data-new-element', null);
        } else {
          tt.transition().duration(duration).style("top", `${posY}px`).style("left", `${posX}px`);
        }
        //triangle.style('opacity', 0).style("top", triangleTop).style("left", triangleLeft).transition().delay(30).duration(150).style('opacity', 1);
        //triangle.style('opacity', 0).transition().delay(30).duration(150).style('opacity', 1);
      }else{
        tt.style("top", `${posY}px`).style("left", `${posX}px`);
        //triangle.style("top", triangleTop).style("left", triangleLeft);
      }
    });
  }

  return {
    showTooltip,
    hideTooltip,
    updatePosition
  };
}

const tooltip = floatingTooltip();
export default tooltip;
